import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import d from "../../../Button/hooks/useButton.js";
import { TypographyElement as T, TypographyVariant as y } from "../../../Typography/types.js";
import N from "../../../Typography/Typography.js";
import { useMemo as s } from "../../../../../external/preact/hooks/dist/hooks.module.js";
/* empty css                  */
import { fixedForwardRef as B } from "../../../../../utils/preact/fixedForwardRef.js";
import { parseClassName as b } from "../../../../../utils/preact/className.js";
import { parseBooleanProp as h } from "../../../../../utils/preact/props.js";
const F = "adyen-pe-filter-button";
function g(o, a) {
  const { className: t, classNameModifiers: i = [], children: m, disabled: r, onClick: n, ...l } = o, c = s(() => b("", t) || "", [t]), p = s(() => h(r), [r]), { classes: u, click: f } = d(c, i, F, p, o, n);
  return /* @__PURE__ */ e("button", { className: u, ref: a, onClick: f, ...l, children: /* @__PURE__ */ e(N, { el: T.DIV, variant: y.BODY, stronger: !0, children: m }) });
}
const _ = B(g);
export {
  _ as default
};
